import { initWatcher as analyticsWatcher } from '@/apps/analytics/store/watcher'
import { initAnketaWatcher as anketaWatcher } from '@/apps/org/store/watcher'

/**
 * Обработчики событий
 * @param {Object} app
 * @param {Object} store
 */
export function initWatcher(app, store) {
  console.log('Start app watcher')
  analyticsWatcher(app, store)
  anketaWatcher(app, store)
}



// WEBPACK FOOTER //
// ./src/apps/watcher.js